import React from 'react';
import './Settings.css';

function JobTemplates({ onBack }) {
    return (
        <div className="settings-component-wrapper">
            <button className="back-button" onClick={onBack}>
                <span className="back-icon">←</span>
                <span>Back to TA Settings</span>
            </button>

            <div className="settings-component-content">
                <div className="settings-component-header">
                    <h1>📋 Job Templates</h1>
                    <p>Manage job posting templates and requirements</p>
                </div>

                <div className="settings-component-body">
                    <div className="settings-info-card">
                        <h3>Job Template Features</h3>
                        <p>This section will allow you to:</p>
                        <ul>
                            <li>Create job posting templates</li>
                            <li>Define job requirements</li>
                            <li>Set qualification criteria</li>
                            <li>Manage job descriptions</li>
                        </ul>
                    </div>

                    <div className="settings-placeholder-message">
                        <span className="placeholder-icon">🚧</span>
                        <p>Job Templates configuration coming soon...</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JobTemplates;
